var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C38.8086 0 50 11.1914 50 25C50 38.8086 38.8086 50 25 50C11.1914 50 0 38.8086 0 25C0 11.1914 11.1914 0 25 0Z",
    fill: "url(#paint0_linear_2460_2317)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9805 42.4219C19.8633 42.4219 15.7422 41.1914 12.8516 38.9844C9.94141 36.7578 8.37891 33.5742 8.37891 30C8.37891 26.543 9.92187 24.0625 11.6602 22.3633C13.0273 21.0352 14.5312 20.1953 15.5859 19.707C15.3516 18.9844 15.0586 18.0273 14.7852 17.0312C14.4336 15.7031 14.082 14.1602 14.082 13.0273C14.082 11.6797 14.375 10.332 15.1562 9.27734C15.9961 8.16406 17.2461 7.57812 18.75 7.57812C19.9219 7.57812 20.9375 8.00781 21.7187 8.76953C22.4609 9.49219 22.9687 10.4492 23.3203 11.4453C23.9258 13.2031 24.1602 15.4102 24.2383 17.6172H25.6836C25.7422 15.4102 25.9766 13.2031 26.6016 11.4453C26.9531 10.4492 27.4414 9.49219 28.2031 8.76953C28.9844 8.00781 30 7.57812 31.1719 7.57812C32.6758 7.57812 33.9453 8.16406 34.7656 9.27734C35.5469 10.332 35.8398 11.6797 35.8398 13.0273C35.8398 14.1602 35.4883 15.7031 35.1367 17.0312C34.8633 18.0273 34.5703 18.9648 34.3359 19.707C35.3906 20.1953 36.8945 21.0352 38.2617 22.3633C40 24.043 41.543 26.543 41.543 30C41.543 33.5938 40 36.7578 37.0703 38.9844C34.1797 41.1914 30.0586 42.4219 24.9414 42.4219H24.9805Z",
    fill: "#633001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8086 8.86719C16.6016 8.86719 15.5664 10.5273 15.5664 12.8516C15.5664 14.6875 16.7578 18.3594 17.2461 19.7852C17.3633 20.0977 17.1875 20.4688 16.875 20.5859C15.0977 21.2891 9.86328 23.8867 9.86328 29.8047C9.86328 36.0547 15.1953 40.7617 25 40.7617H25.0391C34.8633 40.7617 40.1758 36.0547 40.1758 29.8047C40.1758 23.8867 34.9414 21.2891 33.1641 20.5859C32.8516 20.4688 32.6758 20.1172 32.793 19.7852C33.2812 18.3594 34.4727 14.6875 34.4727 12.8516C34.4727 10.5469 33.457 8.86719 31.2305 8.86719C28.0469 8.86719 27.2461 13.4375 27.1875 18.3203C27.1875 18.6523 26.9141 18.9062 26.6016 18.9062H23.4375C23.1055 18.9062 22.8516 18.6328 22.8516 18.3203C22.793 13.418 21.9922 8.86719 18.8086 8.86719Z",
    fill: "#D1884F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0195 38.75C17.8125 38.75 9.86328 34.8438 9.86328 29.8047V29.8242C9.86328 36.0742 15.1953 40.7812 25.0195 40.7812C34.8438 40.7812 40.1758 36.0742 40.1758 29.8242V29.8047C40.1562 34.8633 32.2266 38.75 25.0195 38.75Z",
    fill: "#FEDC90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9961 28.2617C20.9961 29.9609 20.1953 30.8594 19.2187 30.8594C18.2422 30.8594 17.4414 29.9805 17.4414 28.2617C17.4414 26.543 18.2422 25.6641 19.2187 25.6641C20.2148 25.6641 20.9961 26.5625 20.9961 28.2617ZM32.5781 28.2617C32.5781 29.9609 31.7773 30.8594 30.8008 30.8594C29.8242 30.8594 29.0234 29.9805 29.0234 28.2617C29.0234 26.543 29.8242 25.6641 30.8008 25.6641C31.7773 25.6641 32.5781 26.5625 32.5781 28.2617Z",
    fill: "#633001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2317",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54DADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#24C7D6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.a0c4e6ce9186aeb9e93c8ea944046844.svg";
export { ForwardRef as ReactComponent };